/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { ErrorWrapper } from '../ErrorMessage/ErrorAndNoData.styles';

import { Icons } from '../../../Constants/Icons';

const MapLoader = (): JSX.Element => {
  return (
    <ErrorWrapper>
      <img src={Icons.LoadingImg} />
    </ErrorWrapper>
  );
};

export { MapLoader };
